import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core'
import { SuspectList } from '../types/SuspectList';
import { DxDataGridComponent } from 'devextreme-angular';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';

@Component({
  selector: 'suspect-list',
  templateUrl: './suspect-list.component.html'
})
export class SuspectListComponent implements OnChanges {
  @ViewChild('suspectListGrid', { static: true }) suspectListGrid: DxDataGridComponent;
  _suspectList: SuspectList[];
  _miles: number;
  _siteNames: string='';
  toolTipText: string;
  isVisible: boolean = false;
  @Input()
  set suspectList(value: SuspectList[]) {
    this._suspectList = value;
    if( this.suspectList.length > 0){
    this._suspectList.forEach(function(item, index) {
      if( item.apAdvg >= 0 ) {
        item.apDistanceFav = 'Yes'
      }else {
        item.apDistanceFav = 'No'
      }

      if( item.isGasUser === true ) {
        item.isGasUserDisplayText = 'Yes'
      }else {
        item.isGasUserDisplayText = 'No'
      }

      if( item.isAPAccount === true ) {
        item.isAPAccountDisplayText = 'Yes'
      }else {
        item.isAPAccountDisplayText = 'No'
      }

      if( item.isCompetitorAccount === true ) {
        item.isCompetitorAccountDisplayText = 'Yes'
      }else {
        item.isCompetitorAccountDisplayText = 'No'
      }
    
    });
  }
  }

  get suspectList(): SuspectList[] {
    return this._suspectList;
  }

  @Input()
  set miles(value: number) {
    this._miles = value;
  }

  get miles(): number {
    return this._miles;
  }

  @Input()
  set siteNames(value: string) {
    this._siteNames = value;
  }

  get siteNames(): string {
    return this._siteNames;
  }

  chooserMode: string = 'select';
  header1: string;
  header2: string = 'AIR PRODUCTS CONFIDENTIAL - INTERNAL USE ONLY';
  header3: string; 

  constructor() {

  }

  ngOnChanges(): void {
    this.header1 = `${this._miles} miles around ${this.siteNames}`
    this.header3 = `The 'Alt AP' plant is the 2nd closest AP plant. A missing 'Alt Plant' means nothing within ${this.miles}`;
  }

  exportExcel(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('SuspectList');
    exportDataGrid({
      component: this.suspectListGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'SuspectList.xlsx');
        });
    });
    e.cancel = true;
  }

  onCellHoverChanged(event: any) { // TBD
   if (event.rowType === 'header'  && event.column.dataField === 'dunsNumber') {
    if (event.eventType === 'mouseover') {
     this.toolTipText = '';
     this.isVisible = true;
    }
   }
  }

}

